function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @intercom/intercom/no-bare-strings */

import { SkinToneModifiers } from './composer-config';
import { INPUT_RULE_CODE_BLOCK, INPUT_RULE_EMOJI, INPUT_RULE_ORDERED_LIST, INPUT_RULE_UNORDERED_LIST, INPUT_RULE_INLINE_CODE, INPUT_RULE_MARKDOWN_ANCHOR, INPUT_RULE_MARKDOWN_IMAGE } from '@intercom/composer-ember';
import { assetUrl } from '@intercom/pulse/helpers/asset-url';
export default class BaseConfig {
  constructor() {
    _defineProperty(this, "placeholder", 'Start typing');
    _defineProperty(this, "autoFocus", true);
    _defineProperty(this, "customStylesConfig", {
      allowCustomStyles: false
    });
    _defineProperty(this, "initialSelectionLocation", 'start');
    _defineProperty(this, "debug", false);
    _defineProperty(this, "textDirection", 'ltr');
    _defineProperty(this, "tools", [{
      name: 'text-formatter'
    }, {
      name: 'anchor-editor'
    }, {
      name: 'media-inserter'
    }, {
      name: 'video-editor'
    }, {
      name: 'button-editor'
    }, {
      name: 'image-editor',
      options: {
        supportAltAttributeEditing: true
      }
    }, {
      name: 'anchor-link-copy-button',
      options: {
        onClick: _heading => {}
      }
    }, {
      name: 'collapsible-toggle'
    }]);
    _defineProperty(this, "allowedBlocks", ['paragraph', 'image', 'orderedList', 'unorderedList', 'heading', 'subheading', 'codeBlock', 'video', 'button']);
    _defineProperty(this, "hideFromTextFormatter", []);
    _defineProperty(this, "hideFromBlockFormatter", []);
    _defineProperty(this, "allowedInline", ['bold', 'italic', 'anchor', 'code']);
    _defineProperty(this, "inputRules", [INPUT_RULE_CODE_BLOCK, INPUT_RULE_INLINE_CODE, INPUT_RULE_ORDERED_LIST, INPUT_RULE_UNORDERED_LIST, INPUT_RULE_EMOJI, INPUT_RULE_MARKDOWN_ANCHOR, INPUT_RULE_MARKDOWN_IMAGE]);
    _defineProperty(this, "renderOverlaysInPlace", false);
    _defineProperty(this, "singleBlockMode", false);
    _defineProperty(this, "allowImplicitMarginParagraphs", false);
    _defineProperty(this, "allowTextAlignment", true);
    _defineProperty(this, "showAllTextAlignment", false);
    _defineProperty(this, "disableModKAnchor", false);
    _defineProperty(this, "enableAutoLink", false);
    _defineProperty(this, "enableHighlighting", false);
    _defineProperty(this, "experimental", {
      hideInsertersOnMouseOut: false
    });
    _defineProperty(this, "tables", {
      responsive: false,
      containers: false,
      resizeColumns: false
    });
    _defineProperty(this, "images", {
      failedImageUrl: assetUrl('/@intercom/composer-ember/failed-image-upload.svg')
    });
    _defineProperty(this, "updateImages", false);
    _defineProperty(this, "resizeImages", false);
    _defineProperty(this, "skinToneModifier", SkinToneModifiers.None);
    _defineProperty(this, "isInteractivityDisabled", false);
  }
}